import React from 'react';
import styled from 'styled-components';
import HeroImg from '../assets/images/hero.jpeg';
import Button from './Button';
import PText from './PText';
import Typist from 'react-typist';

const HeroStyles = styled.div`
  .hero {
    height: 100vh;
    min-height: 1000px;
    width: 100%;
    text-align: center;
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
  }
  .hero__heading {
    
    font-size: 2rem;
    margin:0 auto;
    margin-bottom: -18.5rem;
    position: relative;
    span {
      display: inline-block;
      width: 100%;
      color:var(--secondary);
    }
    .hero__name {
      font-family: 'Montserrat SemiBold';
      font-size: 5.5rem;
      color: var(--text-s);
    }
  }
  .hero__img {
    max-width: 900px;
    width: 100%;
    height: 600px;
    margin: 0 auto;
    border: 2px solid var(--primary);

  }
  .hero__info {
    margin-top: -8rem;
  }

  @media only screen and (max-width: 768px) {
    .hero {
      min-height: 750px;
    }
    .hero__heading {
      font-size: 1.4rem;
      margin-bottom: -2rem;
      .hero__name {
        font-size: 4.5rem;
      }
    }
    .hero__img {
      height: 300px;
    }
    .hero__info {
      margin-top: 3rem;
    }
  }
`;

export default function HeroSection() {
  return (
    <HeroStyles>
      <div className="hero">
        <div className="container">
          <h1 className="hero__heading">
            <Typist avgTypingDelay={80} cursor={{
              show:false,
                hideWhenDone:true
            }}>
              <span>Hello, I am</span>
              <span className="hero__name">Ojasvi Shaklya</span>
            </Typist>
          </h1>
          <div className="hero__img">
            <img src={HeroImg} alt="" />
          </div>
          <div className="hero__info">
            <PText>
              I'm a software developer.
            </PText>
            <Button btnText="see my projects" btnLink="/projects" />
          </div>
        </div>
      </div>
    </HeroStyles>
  );
}
